import React from 'react';
import { Text, View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import InlineHelpIcon from '@/components/General/inputs/InlineHelpIcon';

/**
 * Shared label header for composite form fields (address, name, checkboxGroup,
 * file) that don't use a single Input with a built-in label. Mirrors the label
 * row rendered by `Input` (label + required `*` + description tooltip).
 */
const FieldLabel = ({ label, required = false, description, testID }) => {
    if(!label && !description) return null;

    return (
        <View style={styles.labelContainer} testID={testID}>
            <Text style={styles.labelText}>
                {label}
                {required && <Text style={styles.required}>*</Text>}
                {description && <InlineHelpIcon text={description} size={16} />}
            </Text>
        </View>
    );
};

const styles = StyleSheet.create(({ colors, fonts }) => ({
    labelContainer: {
        paddingBottom: 6,
    },
    labelText: {
        color: colors.textSecondary,
        fontFamily: fonts.heading,
        fontSize: 13,
        flexShrink: 1,
    },
    required: {
        color: colors.error,
        fontSize: 14,
        fontFamily: fonts.body,
        marginLeft: 2,
    },
}));

export default FieldLabel;
